




































































































































































import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import AppModule from '@/store/modules/app';
import LifecycleModule from '@/store/modules/lifecycle';
import ToastModule from '@/store/modules/toast';
import SiteLayout from '@/layout/fw/index.vue';
import Card from '@/components/Card/StandardCard/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import UserModule from '@/store/modules/user';
import Format from '@/util/Format';
import { UserApi } from '@compassdigital/foodworks.ts.sdk';

@Component({
  beforeRouteEnter(to, from, next) {
    if (AppModule.isLoggedIn) {
      LifecycleModule.terminate();
    }
    next();
  },
  components: {
    SiteLayout,
    Card,
    Textfield,
    PrimaryButton,
  },
})
export default class SetPassword extends Vue {
  private password: string = '';

  private newPassword: string = '';

  private error: string = '';

  private loading: boolean = false;

  private viewablePassword: boolean = false;

  private viewableConfirmPassword: boolean = false;

  private disablePassword: boolean = true;

  private errors: any = {
    lengthError: 'default',
    caseSensivityError: 'default',
    specialCharacterError: 'default',
    confirmPassword: '',
  }

  private alert = '';

  get userID(): string {
    return (this.$route.query.id as string) || '';
  }

  get email(): string {
    // eslint-disable-next-line
    this.expiryLink;
    return (this.$route.query.email as string) || '';
  }

  get expiryLink() {
    const { expiry } = this.$route.query;
    const expiryTimeStamp = Number(expiry);
    // if timestamp is older than 24 hours
    if (moment(expiryTimeStamp).add(7, 'days').isBefore()) {
      const message = 'The link has been expired please click on forgot password';
      this.$router.push({ name: 'login', params: { message } });
    }
    return false;
  }

  get resetToken(): string {
    return (this.$route.query.reset_token as string) || '';
  }

  get passwordStateIcon() {
    if (this.viewablePassword) {
      return 'mdi-eye';
    }
    return 'mdi-eye-off';
  }

  get passwordStateIconConfirm() {
    if (this.viewableConfirmPassword) {
      return 'mdi-eye';
    }
    return 'mdi-eye-off';
  }

  public togglePasswordView() {
    this.viewablePassword = !this.viewablePassword;
  }

  public toggleConfirmPasswordView() {
    this.viewableConfirmPassword = !this.viewableConfirmPassword;
  }

  public get passwordState() {
    if (this.password.length) {
      if (this.password.length < 8 || this.password.length > 15) {
        this.errors.lengthError = 'default';
      }
      if (this.password.length >= 8 && this.password.length <= 15) {
        this.errors.lengthError = 'success';
      }

      const upperCasePattern = /(?=.*[a-z])(?=.*[A-Z])/;
      if (upperCasePattern.test(this.password)) {
        this.errors.caseSensivityError = 'success';
      }
      if (!upperCasePattern.test(this.password)) {
        this.errors.caseSensivityError = 'default';
      }
      // const specialCharPattern = /(?=.*[!@/#'$"%_<>^.&*?(){}[]:;~`=])(?=.*[0-9])/;
      const specialCharPattern = /[-!$%^"&'/*()_+|~=`{}[:;<>?,.@#\]]/;
      if (specialCharPattern.test(this.password)) {
        this.errors.specialCharacterError = 'success';
      }
      if (!specialCharPattern.test(this.password)) {
        this.errors.specialCharacterError = 'default';
      }
      if (this.password.length > 0 && this.newPassword.length > 0) {
        this.disablePassword = false;
      }
      if (this.password.length < 1 || this.newPassword.length < 1) {
        this.disablePassword = true;
      }
    }
    if (this.password.length === 0) {
      this.errors.lengthError = 'default';
      this.errors.caseSensivityError = 'default';
      this.errors.specialCharacterError = 'default';
    }
    return true;
  }

  public onChangeErrors() {
    if (this.password.length < 8 || this.password.length > 15) {
      this.errors.lengthError = 'wrong';
    }
    const upperCasePattern = /(?=.*[a-z])(?=.*[A-Z])/;
    if (!upperCasePattern.test(this.password)) {
      this.errors.caseSensivityError = 'wrong';
    }
    const specialCharPattern = /[-!$%^"&'/*()_+|~=`{}[:;<>?,.@#\]]/;
    if (!specialCharPattern.test(this.password)) {
      this.errors.specialCharacterError = 'wrong';
    }
  }

  public async setPassword() {
    if (this.alert === 'success') {
      return;
    }
    if (this.password.length < 8 || this.password.length > 15) {
      this.errors.lengthError = 'wrong';
    }
    const upperCasePattern = /(?=.*[a-z])(?=.*[A-Z])/;
    if (!upperCasePattern.test(this.password)) {
      this.errors.caseSensivityError = 'wrong';
    }
    const specialCharPattern = /[-!$%^"&'/*()_+|~=`{}[:;<>?,.@#\]]/;
    if (!specialCharPattern.test(this.password)) {
      this.errors.specialCharacterError = 'wrong';
    }
    if (this.password.length > 0
      && this.newPassword.length > 0
      && this.errors.lengthError === 'success'
      && this.errors.specialCharacterError === 'success'
      && this.errors.caseSensivityError === 'success'
    ) {
      if (this.password !== this.newPassword) {
        this.errors.confirmPassword = 'fail';
      }
      if (this.password === this.newPassword) {
        this.errors.confirmPassword = 'success';
      }
    }
    if (this.newPassword.length === 0) {
      if (this.password !== this.newPassword) {
        this.errors.confirmPassword = 'fail';
      }
    }
    if (this.errors.lengthError === 'success'
    && this.errors.specialCharacterError === 'success'
    && this.errors.caseSensivityError === 'success'
    && this.errors.confirmPassword === 'success'
    ) {
      if (!this.userID || !this.resetToken || !this.password) {
        this.alert = 'The form is incomplete please try again';
        this.loading = false;
        return;
      }
      try {
        this.loading = true;
        const userapi = new UserApi(AppModule.apiConfig);
        await userapi.resetPassword(this.userID, {
          password: this.password,
          resetToken: this.resetToken,
        });

        await AppModule.authenticate({
          username: this.email,
          password: this.password,
        });

        await LifecycleModule.init();

        this.$router.push('/home');
        this.alert = 'success';
      } catch (err) {
        if (err.error) {
          this.alert = err.error;
        } else {
          this.alert = 'Something went terribly wrong :(';
        }
      }
      this.loading = false;
    }
  }
}
